import store from './store/index.js';
import axios from './axios';

export default async function verify({ next, to }) {
    // اگر کاربر لاگین نیست، اجازه بده ادامه دهد (auth middleware جداگانه هندل می‌کند)
    if (!store.state.user) {
        return next();
    }

    try {
        // دریافت وضعیت به‌روز کاربر از سرور تا تغییرات بلاک شدن را بلافاصله اعمال کنیم
        const currentUserId = store.state.user.id;
        if (currentUserId) {
            const res = await axios.post('/get-user-profile', { user_id: currentUserId });
            if (res && res.data && res.data.user) {
                const freshUser = res.data.user;
                // به‌روزرسانی استور و localStorage با اطلاعات جدید (شامل is_blocked)
                store.commit('setUser', freshUser);
                localStorage.setItem('user', JSON.stringify(freshUser));
            }
        }
    } catch (e) {
        // در صورت خطا، از داده فعلی استور استفاده می‌کنیم
    }

    const user = store.state.user;

    // اگر کاربر ادمین است، اجازه دسترسی بده
    if (user && user.level === 'admin') {
        return next();
    }

    // اگر کاربر مسدود شده باشد، همیشه به صفحه Blocked هدایت کن (به جز خود صفحه Blocked)
    if (user && user.is_blocked) {
        if (to.name !== 'BlockedUser') {
            return next({ name: 'BlockedUser' });
        }
        return next();
    }

    // اگر کاربر هنوز verify نشده (kv = '0') یا رد شده (kv = '3')
    if (user && (user.kv === '0' || user.kv === undefined || user.kv === null || user.kv === '3')) {
        if (to.name !== 'VerifyUser' && to.name !== 'BlockedUser') {
            return next({ name: 'VerifyUser' });
        }
    }

    return next();
}
